import { useMutation, useQueryClient } from '@tanstack/react-query';
import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { useSetNotification } from '../../../context/Notification';
import { USERS_LIST_KEY } from './constants';

type UseDeactivateCareManagerParams = {
    external_user_id: number;
};

const useDeactivateCareManager = () => {
    const req = useRequest();
    const setNotification = useSetNotification();
    const queryClient = useQueryClient();

    return useMutation<unknown, { errors: string[] }, UseDeactivateCareManagerParams>({
        mutationFn: (body) => {
            return req({
                url: `${envVars.API_RTM_HOSTNAME}enterprise/care-manager/deactivate/`,
                method: 'POST',
                body: JSON.stringify(body)
            });
        },
        onSuccess: () => {
            setNotification({ message: 'User deactivated', icon: 'checkmark' });
            queryClient.invalidateQueries({ queryKey: [USERS_LIST_KEY] });
        },
        onError: (error: { errors: string[] }) => {
            return error;
        }
    });
};

export default useDeactivateCareManager;
